import {action} from 'mobx';

import {EXPIRE_TIME, EXPIRES_IN, EXPIRES_PENDING} from '../../../constants/storeConstants';
import {STATE_PENDING, STATE_FULFILLED, STATE_REJECTED} from '../../../constants/asyncConstants';
import serverApi from '../../../utils/serverApi';
import ApiMapBaseStore from '../common/apiMapBaseStore';

/**
 * ApiContentRequestGetOneStore
 */
class ApiContentRequestGetOneStore extends ApiMapBaseStore {
  /**
   * Fetches content request information from the server.
   *
   * @param {string} requestId
   */
  @action makeRequest(requestId) {
    const safeRequestId = String(requestId);

    this.dataMap.set(safeRequestId, {
      state: STATE_PENDING,
      [EXPIRE_TIME]: Date.now() + EXPIRES_PENDING,
      data: null,
      error: null,
    });

    serverApi.contentRequestGetOne(safeRequestId).then(
      action('contentRequestGetOneSuccess', (foundRequest) => {
        this.dataMap.set(safeRequestId, {
          state: STATE_FULFILLED,
          [EXPIRE_TIME]: Date.now() + EXPIRES_IN,
          data: foundRequest,
          error: null,
        });
      }),
      action('contentRequestGetOneError', (contentRequestGetOneError) => {
        this.dataMap.set(safeRequestId, {
          state: STATE_REJECTED,
          [EXPIRE_TIME]: null,
          data: null,
          error: contentRequestGetOneError,
        });
      })
    );
  }
}

export default new ApiContentRequestGetOneStore();
